import { useEffect } from 'react'
import { ConfigProvider } from 'antd'
import ko_KR from 'antd/locale/ko_KR'
import useStore from '@/hooks/useStore'
import Header from '@/components/Header'
import Content from '@/components/Content'
import Footer from '@/components/Footer'
import '@cesiumgs/cesium-analytics/Cesium/Widgets/widgets.css'

window.CESIUM_BASE_URL = '/nddt/portal/ionsdk'
function Home(props: any) {
  const uiStore = useStore('uiStore')

  const resizeUpdate = (e: any) => {
    uiStore.getUiHeight(e)
  }

  useEffect(() => {
    // eslint-disable-next-line n/prefer-global/process
    const isDev = process.env.NODE_ENV === 'development'
    const id = localStorage.getItem('JSESSIONID') || ''
    const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id
    if (!id2) {
      window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/login/getLoginView.do`
    }

    window.addEventListener('resize', resizeUpdate)
    return () => {
      window.removeEventListener('resize', resizeUpdate)
    }
  }, [])

  return (
        <ConfigProvider
            locale={ko_KR}
            prefixCls={'nd'}
            theme={{
              token: {
                fontFamily: 'spoqa, sans-serif',
              },
            }}
        >
            <Header/>
            <Content mapLoadedCallback={props.mapLoadedCallback}/>
            <Footer/>
        </ConfigProvider>
  )
}
export default Home
